import type { DetailedSolutionApiResponse } from "../../types";
import { EditSolutionFormValues } from "./types";

export const createEditSolutionFormValues = (
  solutionDetails: DetailedSolutionApiResponse,
): EditSolutionFormValues => ({
  "solution-name": solutionDetails.name || "",
  "solution-vbc-website-display-name":
    solutionDetails.vbcWebsiteDisplayName || "",
  "solution-developer": solutionDetails.developer || "",
  "solution-short-description": solutionDetails.shortDescription || "",
  "country-select": solutionDetails.country || [],
  "solution-development-stage": solutionDetails.developmentStage || [],
  "solution-assessment-methodology":
    solutionDetails.assessmentMethodology || null,
  "solution-intervention-type": solutionDetails.interventionType || null,
  "solution-is-ready-for-sale": solutionDetails.isReadyForSale || false,
  "solution-not-ready-for-sale-reason":
    solutionDetails.notReadyForSaleReason || null,
  "solution-start-date": solutionDetails.date?.start || null,
  "solution-end-date": solutionDetails.date?.end || null,
  "solution-is-carbon-offset":
    solutionDetails.isUsedForCarbonOffsetting || false,
  latitude: solutionDetails.coordinates?.latitude.toString() || "",
  longitude: solutionDetails.coordinates?.longitude.toString() || "",
  "location-pin-map-link": solutionDetails.locationPinMapLink || "",
  "solution-sdg": solutionDetails.SDG || [],
  interventions:
    solutionDetails.interventions?.map((intervention, index) => ({
      action: intervention.action,
      ecosystem: intervention.ecosystem,
      interventionCounter: index + 1,
    })) || [],
  outcomes:
    solutionDetails.outcomes?.v3?.map((outcome, index) => ({
      unit: outcome.unit,
      value: outcome.value.toString(),
      "unit-of-sale": outcome.isUnitOfSale,
      "outcome-start-date": outcome.startDate ?? 0,
      "outcome-end-date": outcome.endDate ?? null,
      outcomeCounter: index + 1,
      origin: "saved",
    })) || [],
  "outcomes-v2": solutionDetails.outcomes?.v2 || [],
  pillars: solutionDetails.pillars || {},
  "programme-info": {
    "carbon-crediting-programme":
      solutionDetails.programmeInfo?.carbonCreditProgramme || [],
    "carbon-accounting-methodology":
      solutionDetails.programmeInfo?.accountingMethodology || "",
    "description-document":
      solutionDetails.programmeInfo?.projectDescriptionDocument || "",
    "asset-type": solutionDetails.programmeInfo?.assetType || null,
  },
  "internal-details": {
    "website-url": solutionDetails.internalUseOnly?.websiteUrl || "",
    "xero-account-number":
      solutionDetails.internalUseOnly?.xeroAccountNumber || "",
    "research-team-notes":
      solutionDetails.internalUseOnly?.researchTeamNotes || "",
    "additional-resources-link":
      solutionDetails.internalUseOnly?.additionalResourceLink || "",
  },
  "commercial-information": {
    "minimum-order":
      solutionDetails.commercialInformation?.minimumOrder ?? null,
  },
  "satellite-imagery":
    solutionDetails.satelliteImagery?.map((satelliteImage, index) => ({
      ...satelliteImage,
      satelliteImageCounter: index + 1,
    })) || [],
  narrative: {
    "project-information": solutionDetails.narrative?.projectInformation || "",
    "area-through-time": solutionDetails.narrative?.areaThroughTime || "",
    "good-for-people": solutionDetails.narrative?.goodForPeople || "",
    "good-for-earth": solutionDetails.narrative?.goodForEarth || "",
  },
  "risk-monitoring": {
    "is-risk-alert-enabled": solutionDetails.riskMonitoring?.isEnabled || false,
    "buffer-value-km": solutionDetails.riskMonitoring?.buffer || 10,
    "geospatial-file": solutionDetails.riskMonitoring?.geospatialFile || null,
    "geospatial-id": solutionDetails.riskMonitoring?.geospatialDataId || null,
  },
});
